import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './core/lib/i18n'  // Initialize i18n
import App from './pages/App.jsx'  // Use the App with AuthProvider
import ErrorBoundary from './core/components/ErrorBoundary'

createRoot(document.getElementById('root')).render(
  // Temporarily disabled StrictMode for debugging
  // <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  // </StrictMode>,
)
